import { render, staticRenderFns } from "./divided.vue?vue&type=template&id=e3803c60&scoped=true&"
import script from "./divided.vue?vue&type=script&lang=js&"
export * from "./divided.vue?vue&type=script&lang=js&"
import style0 from "./divided.vue?vue&type=style&index=0&id=e3803c60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3803c60",
  null
  
)

export default component.exports